import { gql } from "@apollo/client";

export default gql`
  query getAiHelpGaps($data: AiHelpGapsInput){
    getAiHelpGaps(data: $data){
        success
        data{
            _id
            customer
            cPerson
            question
            resolvedAt
            article
            createdAt
        }
        code
        message
    }
}
`
